import { Article } from '@thro-types/leihbar';

import { TFunction } from 'i18next';
import { pick } from 'lodash';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const articleValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    sku: yup.string().required(t(translations.validation.required())),
    isVisible: yup.boolean().label(t(translations.pages.leihbar.article.create.isVisible())),
    internalNote: yup.string()
  });

export const useArticleInitialValues = (initialArticle: Article | undefined) => {
  return initialArticle
    ? {
        ...pick(initialArticle, ['id', 'sku', 'isVisible', 'product', 'internalNote', 'productId']),
        internalNote: initialArticle.internalNote || '' // Required because it could be null and then the validation would fail
      }
    : {
        sku: '',
        isVisible: true,
        internalNote: ''
      };
};
